import { createAction, props } from '@ngrx/store';
import { IBanner } from '@nx-ng/types';

export const dismissBanner = createAction('[Core:Banner] Dismiss');
export const resetBanner = createAction('[Core:Banner] Reset');
export const setBannerDetail = createAction(
  '[Core:Banner] Set Detail',
  props<{ bannerDetails: IBanner }>()
);
